var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    id: "Ellipse-6",
    fill: "#0D9C7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0987 28.2755L28.4869 28.2755C29.4782 26.7048 31.1004 25.5625 33 25.1983L33 15.2972C33 14.0305 31.9382 13 30.6331 13L28.9382 13L28.9382 13.8627C28.9382 15.0053 27.9804 15.935 26.8031 15.935L20.1969 15.935C19.0196 15.935 18.0618 15.0053 18.0618 13.8627L18.0618 13L16.3669 13C15.0618 13 14 14.0305 14 15.2972L14 34.7028C14 35.9695 15.0618 37 16.3669 37L29.8379 37C28.3767 35.7549 27.45 33.9119 27.45 31.8586C27.45 31.1438 27.5627 30.4545 27.7707 29.807L18.0987 29.807C17.663 29.807 17.3097 29.4641 17.3097 29.0412C17.3097 28.6184 17.663 28.2755 18.0987 28.2755L18.0987 28.2755ZM18.0987 19.2272L28.9025 19.2272C29.3382 19.2272 29.6915 19.57 29.6915 19.9929C29.6915 20.4158 29.3382 20.7587 28.9025 20.7587L18.0987 20.7587C17.663 20.7587 17.3097 20.4158 17.3097 19.9929C17.3097 19.57 17.663 19.2272 18.0987 19.2272L18.0987 19.2272ZM18.0987 22.2433L28.9025 22.2433C29.3382 22.2433 29.6915 22.5861 29.6915 23.009C29.6915 23.4319 29.3382 23.7748 28.9025 23.7748L18.0987 23.7748C17.663 23.7748 17.3097 23.4319 17.3097 23.009C17.3097 22.5861 17.663 22.2433 18.0987 22.2433L18.0987 22.2433ZM18.0987 25.2594L28.9025 25.2594C29.3382 25.2594 29.6915 25.6022 29.6915 26.0251C29.6915 26.448 29.3382 26.7909 28.9025 26.7909L18.0987 26.7909C17.663 26.7909 17.3097 26.448 17.3097 26.0251C17.3097 25.6022 17.663 25.2594 18.0987 25.2594L18.0987 25.2594Z",
    id: "Group",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4226 11L20.5774 11C20.259 11 20 11.2794 20 11.6229L20 13.3771C20 13.7206 20.259 14 20.5774 14L27.4226 14C27.741 14 28 13.7206 28 13.3771L28 11.6229C28 11.2794 27.741 11 27.4226 11L27.4226 11Z",
    id: "Group",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 31.5C31 29.567 32.567 28 34.5 28C36.433 28 38 29.567 38 31.5C38 33.433 36.433 35 34.5 35C32.567 35 31 33.433 31 31.5Z",
    id: "\\xD3valo",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 26C31.243 26 29 28.243 29 31C29 33.757 31.243 36 34 36C36.757 36 39 33.757 39 31C39 28.243 36.757 26 34 26L34 26ZM36.0925 33.7325C35.9584 33.8303 35.8015 33.8775 35.646 33.8775C35.4182 33.8775 35.1934 33.7763 35.0466 33.5847L33.4013 31.4361C33.3048 31.3102 33.2527 31.1572 33.2527 31L33.2527 29.4437C33.2527 29.0412 33.5873 28.7148 34 28.7148C34.4128 28.7148 34.7473 29.0411 34.7473 29.4437L34.7473 30.7578L36.2441 32.7123C36.491 33.0349 36.4232 33.4916 36.0925 33.7325L36.0925 33.7325Z",
    id: "Group",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporteIcon);
export default __webpack_public_path__ + "static/media/reporteIcon.b6f86c54e02f8d972e9f70e1136bcc1f.svg";
export { ForwardRef as ReactComponent };